import React from "react";
import SectionContainer from "../common/SectionContainer";

function WhoWeWorkWith() {
const pillars = [
{
title: "Strategy First",
description:
"Every engagement begins with business objectives, market realities and growth opportunities before marketing tactics are discussed."
},
{
title: "Technology Enabled",
description:
"Modern websites, automation, analytics and AI workflows create systems that support long-term scale."
},
{
title: "Execution Focused",
description:
"Ideas only matter when they are implemented. Our approach combines consulting, implementation and continuous optimization."
}
];

return ( <SectionContainer background="#ffffff"> <div className="why-ekritfly">

    <div className="why-ekritfly-left">
      <span className="section-kicker">
        Why EkritFly
      </span>

      <h2>
        Growth Is Never A
        Marketing Problem.
      </h2>

      <p>
        Sustainable growth happens when strategy,
        marketing and technology work together.
        We help organizations build systems that
        generate demand, improve conversion and
        create long-term competitive advantages.
      </p>
    </div>

    <div className="why-ekritfly-right">
      {pillars.map((pillar, index) => (
        <div
          key={pillar.title}
          className="why-pillar"
        >
          <div className="pillar-number">
            0{index + 1}
          </div>

          <div>
            <h3>{pillar.title}</h3>

            <p>{pillar.description}</p>
          </div>
        </div>
      ))}
    </div>

  </div>
</SectionContainer>

);
}

export default WhoWeWorkWith;
